module.exports = __webpack_public_path__ + "img/icon_sportMenu_pingpong.8b1149d6.svg";